// Helper function to decide if the item has location
export default (item) => {
  if (!item.location) return false;
  const locationIncluded = Object.keys(item).includes('location');
  const hasLatLng = item.location.length === 2;
  const hasValidValues = item.location[0] !== null && item.location[1] !== null;
  return (locationIncluded || hasLatLng) && hasValidValues;
};
